
parentFeedbackContent.classy.controller({
    name: 'parentFeedbackContentController',
    inject: ['$scope', '$rootScope', 'authServiceFactory', 'ApplicationService', 'ParentCommentsModelService', '$modal', '$sce'],
    init: function()
    {    
   		this.$.$sce = this.$sce; 
        this.$.ParentCommentsModelService = this.ParentCommentsModelService;
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.items = this.ParentCommentsModelService.get();
        console.log(this.$.items);
        this.$.stats = {'positive': 0, 'negative': 0, 'ty': 0, 'suggestion': 0, 'spanheb': 0, 'other': 0};
        for (var i = 0; i < this.$.items.length; i++) {
        	if (this.$.items[i].Type==19) 
        		this.$.stats.positive++;
        	else if (this.$.items[i].Type==20) 
        		this.$.stats.negative++;
        	else if (this.$.items[i].Type==21) 
        		this.$.stats.ty++;
        	else if (this.$.items[i].Type==22) 
        		this.$.stats.suggestion++;
        	else if (this.$.items[i].Type==24) 
        		this.$.stats.spanheb++;
        	else if (this.$.items[i].Type==23) 
        		this.$.stats.other++;
            else 
                this.$.stats.other++;
        }
        console.log(this.$.stats);
    },
    momentFormat: function(datetime)
    {
        var notetime = moment(datetime)
        return notetime.format('MMM Do, YYYY - h:mm a');
    }
});
